<!--
File Name          : egg-drop.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="lesson-component-container">
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.EGG_SURVIVAL)">
        <div class="datum-title">Egg Survival</div>
        <div class="datum-value"><img width="48" height="48" style="max-height:100%;" [src]="(results?.impact_N ?? 0) < 50 ? '/assets/lessons/impact/WholeEgg_Happy.svg' : '/assets/lessons/impact/CrackedEgg_Spilled.svg'" [alt]="(results?.impact_N ?? 0) < 50 ? 'Egg survived' : 'Egg cracked'"/></div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.IMPACT_G)">
        <div class="datum-title">Impact Gs</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.impact_G)}} G</div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.IMPACT_ACCEL)">
        <div class="datum-title">Impact Acceleration</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.impact_m_per_s2)}} m/s<sup>2</sup></div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.IMPACT_FORCE)">
        <div class="datum-title">Impact Force</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.impact_N)}} N</div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.IMPACT_TIME)">
        <div class="datum-title">Impact Time</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.impact_duration_s ? results!.impact_duration_s * 1000 : undefined)}} ms</div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.MAX_VELOCITY)">
        <div class="datum-title">Maximum Velocity</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.max_velocity)}} m/s</div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.DROP_TIME)">
        <div class="datum-title">Drop Time</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.flight_time)}} s</div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.DROP_HEIGHT)">
        <div class="datum-title">Drop Height</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.drop_height_m)}} m</div>
    </div>
    <div class="scalar-datum" *ngIf="scalars.includes(ImpactFields.ASTRONAUT_SURVIVAL)">
        <div class="datum-title">Astronaut Survival</div>
        <div class="datum-value"><img width="48" height="48" style="max-height:100%;" [src]="(results?.impact_G ?? -1) > 20 ? '/assets/lessons/impact/RocketShip_Broken.svg' : '/assets/lessons/impact/RocketShip_wStars.svg'" [alt]="(results?.impact_G ?? -1) > 20 ? 'Astronaut did not survive' : 'Astronaut survived'"/></div>
    </div>


    @if(screenservice.isMobile) {
        <div class="chart-container mobile-chart-options">
            <div style="text-align: center; margin-bottom: 8px;">Select to Graph</div>
            <div class="chart-controls">
                <dx-button 
                    *ngFor="let series of availableDataSeries"
                    [text]="series.text"
                    icon="datatrending"
                    [disabled]="false"
                    
                    stylingMode="contained"
                    type="default"
                    (onClick)="openMobileChart(series.valueField)"
                ></dx-button>
            </div>
        </div>
    }
    @else {
        <div class="chart-container">
            <div class="chart-controls">
                <div>Select to Graph</div>
                <dx-button-group
                    [items]="availableDataSeries"
                    [(selectedItemKeys)]="selectedDataSeries"
                    selectionMode="single"
                    stylingMode="outlined"
                    keyExpr="valueField"
                    ></dx-button-group>
            </div>
            <div class="chart-with-labels" style="height: calc(100% - 36px);">
            <dx-chart
                [dataSource]="results?.data??[]"
                style="height: 100%;"
                (onDrawn)="onChartDrawn($event)"
                (onZoomEnd)="onChartZoomEnd($event)"
            >
            <dxo-zoom-and-pan
                argumentAxis="both"
                valueAxis="none"
                [allowMouseWheel]="true"
                [allowTouchGestures]="true"> <!-- or "zoom" | "pan" | "none" -->
            </dxo-zoom-and-pan>
            <dxo-tooltip
                    [enabled]="true"
                    [customizeTooltip]="customizeTooltip"
            ></dxo-tooltip>
            <dxo-size
                [height]="360">
            </dxo-size>
                <!-- <dxo-title text="Acceleration Magnitude" horizontalAlignment="center"></dxo-title> -->
                <dxo-legend [visible]="false"></dxo-legend>
                <dxo-common-series-settings
                    #seriesSettings
                    argumentField="timestamp"
                    type="spline"
                >
                    <dxo-point [visible]="false"></dxo-point>
                </dxo-common-series-settings>
                <dxo-common-axis-settings [valueMarginsEnabled]="true">
                    <dxo-label>
                        <dxo-font size="18"></dxo-font>
                    </dxo-label>
                </dxo-common-axis-settings>
                <dxi-series *ngIf="isSeriesSelected('acceleration')" color="#424242" valueField="accel_magnitude" axis="accel_axis"></dxi-series>
                <dxi-series *ngIf="isSeriesSelected('velocity')" color="#424242" valueField="velocity" axis="vel_axis"></dxi-series>
                <dxi-series *ngIf="isSeriesSelected('position')" color="#424242" valueField="position" axis="pos_axis"></dxi-series>
                <dxo-argument-axis [valueMarginsEnabled]="false">
                    <dxi-strip [startValue]="results?.timeline?.hold_start" [endValue]="results?.timeline?.hold_end" color="#66bb6a"></dxi-strip>
                    <dxi-strip [startValue]="results?.timeline?.freefall_start" [endValue]="results?.timeline?.freefall_end" color="#ffcc80"></dxi-strip>
                    <dxi-strip [startValue]="results?.timeline?.freefall_end" [endValue]="results?.timeline?.settling_start" color="#ef9a9a"></dxi-strip>
                    <dxi-strip [startValue]="results?.timeline?.settling_start" [endValue]="results?.timeline?.settling_end" color="#90caf9"></dxi-strip>
                    <dxo-title text="Time (s)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxo-argument-axis>
                <dxi-value-axis *ngIf="isSeriesSelected('acceleration')" type="logarithmic" [linearThreshold]="0" name="accel_axis" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Acceleration (G)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                    <dxo-chart-label
                        [customizeText]="roundDownChartLabel"
                    ></dxo-chart-label>
                </dxi-value-axis>
                <dxi-value-axis *ngIf="isSeriesSelected('velocity')"  type="continuous" name="vel_axis" [wholeRange]="{ startValue: velocityMin, endValue: velocityMax }" [minValueMargin]="0.2" [maxValueMargin]="0.2">
                    <dxo-title text="Velocity (m/s)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
                <dxi-value-axis *ngIf="isSeriesSelected('position')"  type="continuous" name="pos_axis" [wholeRange]="{ startValue: positionMin, endValue: positionMax }" [minValueMargin]="0.2" [maxValueMargin]="0.2">
                    <dxo-title text="Distance (m)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
            </dx-chart>
                <div class="zone-label-overlay">
                    <span class="zone-label" data-zone="held" style="color: #1b5e20">Held</span>
                    <span class="zone-label" data-zone="drop" style="color: #e65100">Drop</span>
                    <span class="zone-label" data-zone="impact" style="color: #b71c1c">Impact</span>
                    <span class="zone-label" data-zone="settling" style="color: #0d47a1">Settling</span>
                </div>
            </div>
        </div>
    }


    
    
</div>

<dx-popup
    [visible]="mobileChartSelection !== null"
    [showTitle]="true"
    [title]="getChartPopupTitle()"
     width="100%"
     height="100%"
     maxWidth="100%"
     maxHeight="100%"
    [dragEnabled]="false"
    [showCloseButton]="true"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    (onHiding)="mobileChartSelection = null"
    (onShowing)="onPopupShowing()"
    (onShown)="onPopupShown()"
    >
    <div class="popup-chart-body" [attr.data-chart-key]="chartKey">
        <div class="chart-with-labels" style="flex:1 1 auto;min-height:0;width:100%;">
        <dx-chart
                    [dataSource]="results?.data??[]"
                    style="height:100%;width:100%;"
                    (onDrawn)="onChartDrawn($event)"
                    (onZoomEnd)="onChartZoomEnd($event)"
                >
                <dxo-zoom-and-pan
                    argumentAxis="both"
                    valueAxis="none"
                    [allowMouseWheel]="true"
                    [allowTouchGestures]="true"> <!-- or "zoom" | "pan" | "none" -->
                </dxo-zoom-and-pan>
                <dxo-tooltip
                        [enabled]="true"
                        [customizeTooltip]="customizeTooltip"
                        [zIndex]="10000"
                ></dxo-tooltip>
                    <!-- <dxo-title text="Acceleration Magnitude" horizontalAlignment="center"></dxo-title> -->
                    <dxo-legend [visible]="false"></dxo-legend>
                    <dxo-common-series-settings
                        #seriesSettings
                        argumentField="timestamp"
                        type="spline"
                    >
                        <dxo-point [visible]="false"></dxo-point>
                    </dxo-common-series-settings>
                    <dxo-common-axis-settings [valueMarginsEnabled]="true">
                        <!-- <dxo-label>
                            <dxo-font size="18"></dxo-font>
                        </dxo-label> -->
                    </dxo-common-axis-settings>
                    <dxi-series *ngIf="mobileChartSelection == 'acceleration'" color="#424242" valueField="accel_magnitude" axis="accel_axis"></dxi-series>
                    <dxi-series *ngIf="mobileChartSelection == 'velocity'" color="#424242" valueField="velocity" axis="vel_axis"></dxi-series>
                    <dxi-series *ngIf="mobileChartSelection == 'position'" color="#424242" valueField="position" axis="pos_axis"></dxi-series>
                    <dxo-argument-axis [valueMarginsEnabled]="false">
                        <dxi-strip [startValue]="results?.timeline?.hold_start" [endValue]="results?.timeline?.hold_end" color="#66bb6a"></dxi-strip>
                        <dxi-strip [startValue]="results?.timeline?.freefall_start" [endValue]="results?.timeline?.freefall_end" color="#ffcc80"></dxi-strip>
                        <dxi-strip [startValue]="results?.timeline?.freefall_end" [endValue]="results?.timeline?.settling_start" color="#ef9a9a"></dxi-strip>
                        <dxi-strip [startValue]="results?.timeline?.settling_start" [endValue]="results?.timeline?.settling_end" color="#90caf9"></dxi-strip>
                        <dxo-title text="Time (s)">
                            <!-- <dxo-font size="24" weight="bold"></dxo-font> -->
                        </dxo-title>
                    </dxo-argument-axis>
                    <dxi-value-axis *ngIf="mobileChartSelection == 'acceleration'" type="logarithmic" [linearThreshold]="0" name="accel_axis" [minValueMargin]="0.1" [maxValueMargin]="0.1" [tickInterval]="1">
                        <dxo-title text="Acceleration (G)">
                            <dxo-font size="16" weight="bold"></dxo-font>
                        </dxo-title>
                        <dxo-chart-label
                            [customizeText]="roundDownChartLabel"
                        ></dxo-chart-label>
                    </dxi-value-axis>
                    <dxi-value-axis *ngIf="mobileChartSelection == 'velocity'"  type="continuous" name="vel_axis" [wholeRange]="{ startValue: velocityMin, endValue: velocityMax }" [minValueMargin]="0.2" [maxValueMargin]="0.2">
                        <dxo-title text="Velocity (m/s)">
                            <dxo-font size="16" weight="bold"></dxo-font>
                        </dxo-title>
                    </dxi-value-axis>
                    <dxi-value-axis *ngIf="mobileChartSelection == 'position'"  type="continuous" name="pos_axis" [wholeRange]="{ startValue: positionMin, endValue: positionMax }" [minValueMargin]="0.2" [maxValueMargin]="0.2">
                        <dxo-title text="Distance (m)">
                            <dxo-font size="16" weight="bold"></dxo-font>
                        </dxo-title>
                    </dxi-value-axis>
                </dx-chart>
                <div class="zone-label-overlay">
                    <span class="zone-label" data-zone="held" style="color: #1b5e20">Held</span>
                    <span class="zone-label" data-zone="drop" style="color: #e65100">Drop</span>
                    <span class="zone-label" data-zone="impact" style="color: #b71c1c">Impact</span>
                    <span class="zone-label" data-zone="settling" style="color: #0d47a1">Settling</span>
                </div>
            </div>
        </div>
    <div class="popup-portrait-msg">
        <span>Device must be in Landscape to view graphs.</span>
    </div>
</dx-popup>

